export const RESET_PASSWORD_CARD_TITLE = 'Reset your password';
export const CANCEL_RESET_PASSWORD_BUTTON_TEXT = 'Cancel password reset';
